import { render, staticRenderFns } from "./DispatchVehicles.vue?vue&type=template&id=08fb4f36&scoped=true"
import script from "./DispatchVehicles.vue?vue&type=script&lang=js"
export * from "./DispatchVehicles.vue?vue&type=script&lang=js"
import style0 from "./DispatchVehicles.vue?vue&type=style&index=0&id=08fb4f36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fb4f36",
  null
  
)

export default component.exports